<style lang="scss">
/* ===== PC Layout Container ===== */
.page-inner {
  max-width: 1200px;
  margin: 0 auto;
}

/* ===== Modal Width Override ===== */
:deep(.ant-modal) {
  max-width: none !important;
}

.not-developer-praent {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

.not-developer-div {
  padding: 1.5rem;
  width: fit-content;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  text-align: center;

  p {
    font-size: 1rem;
    color: #333;
    margin-bottom: 1rem;
  }
}

/* ===== Tabs Container ===== */
.data-tabs-card {
  border-radius: 8px;

  :deep(.ant-tabs-nav) {
    margin-bottom: 0;
  }

  :deep(.ant-card-body) {
    padding: 0;
  }
}

/* ===== Toolbar ===== */
.table-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  flex-wrap: wrap;
}

/* ===== Mobile Card List ===== */
.plugin-auth-card-list,
.plugin-agent-card-list {
  display: none;
  flex-direction: column;
  gap: 12px;
  padding: 16px;

  .mobile-card {
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

    :deep(.ant-card-body) {
      padding: 12px 14px;
    }
  }

  .mobile-card-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
  }

  .mobile-card-title {
    font-weight: 600;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.88);
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mobile-card-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 10px;
  }

  .mobile-field {
    display: flex;
    gap: 8px;
    font-size: 13px;
  }

  .mobile-label {
    color: rgba(0, 0, 0, 0.45);
    min-width: 80px;
    flex-shrink: 0;
    font-size: 12px;
    line-height: 30px;
  }

  .mobile-value {
    flex: 1;
    min-width: 0;
  }

  .mobile-card-foot {
    display: flex;
    gap: 8px;
    padding-top: 8px;
    border-top: 1px solid #f5f5f5;
    flex-wrap: wrap;
  }
}

/* ===== Pagination ===== */
.table-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px 16px;
}

/* ===== History Notice ===== */
.history-notice {
  padding: 8px 12px;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  margin-bottom: 12px;
  color: #ad6800;
  font-size: 12px;
}

.history-empty {
  text-align: center;
  padding: 16px;
  color: #999;
  font-size: 13px;
}

/* ===== Mobile Responsive ===== */
@media screen and (max-width: 768px) {
  .ant-layout-content {
    padding: 12px !important;
  }

  /* Plugin Auth Tab Toggle */
  .plugin-auth-table-pc,
  .plugin-auth-pagination {
    display: none !important;
  }

  .plugin-auth-card-list {
    display: flex !important;
  }

  /* Plugin Agent Tab Toggle */
  .plugin-agent-table-pc,
  .plugin-agent-pagination {
    display: none !important;
  }

  .plugin-agent-card-list {
    display: flex !important;
  }

  .table-toolbar {
    padding: 10px 12px;
  }

  .data-tabs-card :deep(.ant-card-head) {
    padding: 0 12px;
    min-height: 44px;
  }

  .not-developer-div {
    padding: 1rem;
  }
}

/* Very small phones */
@media screen and (max-width: 480px) {
  .ant-layout-content {
    padding: 8px !important;
  }
}
</style>
<template>
  <a-layout style="min-height: 100vh;">
    <UserHead />
    <a-layout>
      <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
        <HeadTop />
      </a-layout-header>
      <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
        <div class="page-inner">
          <div v-if="isDeveloper == 0" class="not-developer-praent">
            <div class="not-developer-div">
              <p>您还不是开发者，暂时无法查看本页面喔~</p>
              <div style="text-align: center; width: fit-content; margin: 1rem auto 0.5rem;">
                <a-button type="primary" @click="goApiUrl">成为开发者</a-button>
              </div>
            </div>
          </div>

          <a-tabs v-if="isDeveloper != 0" v-model:activeKey="activeName" class="data-tabs-card">
            <a-tab-pane tab="授权列表" key="first">
              <div class="table-toolbar">
                <a-select v-model:value="select_includes" allowClear placeholder="Select" style="width: 160px;"
                  @change="getPluginAuth()">
                  <a-select-option label="全部插件" :value="-1" />
                  <a-select-option v-for="item in deveploerData.list" :key="item.id" :value="item.id">
                    {{ item.name || item.includes_name }}
                  </a-select-option>
                </a-select>
                <a-input style="width: 200px;" v-model:value="PluginAuth.keyword" placeholder="邮箱/授权字段关键词" />
                <a-button type="primary" @click="getPluginAuth()">搜索</a-button>
              </div>

              <!-- PC端授权列表表格 -->
              <a-table class="plugin-auth-table-pc" :data-source="PluginAuth.data" :pagination="false" row-key="authId"
                :scroll="{ x: 1600 }" size="small" bordered :columns="pluginAuthColumns">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'host'">
                    <a-input v-model:value="record.host" @focus="cacheOrigin(record, 'host')"
                      @blur="onUpdateHost(record)" placeholder="请输入域名/IP"></a-input>
                  </template>
                  <template v-else-if="column.key === 'endDate'">
                    <a-tooltip :title="'到期: ' + record.endDate">
                      <a-tag
                        :color="getEndDateColor(record.endDate) === 1 ? 'green' : (getEndDateColor(record.endDate) === 2 ? 'gold' : 'red')">
                        {{ record.endDate }}
                      </a-tag>
                    </a-tooltip>
                  </template>
                  <template v-else-if="column.key === 'isFree'">
                    <a-tag :color="record.isFree === 1 ? 'default' : 'green'">{{ record.isFree === 1 ? '免费' : '付费'
                    }}</a-tag>
                  </template>
                  <template v-else-if="column.key === 'state'">
                    <a-tag :color="record.state === 1 ? 'green' : 'red'">{{ record.state === 1 ? '正常' : '禁用' }}</a-tag>
                  </template>
                  <template v-else-if="column.key === 'modifyHistory'">
                    <a-button size="small" type="link" :disabled="!record.modifyHistory"
                      @click="openHistoryDialog(record)">
                      {{ parseHistory(record.modifyHistory).length }} 条
                    </a-button>
                  </template>
                  <template v-else-if="column.key === 'banDesc'">
                    <span>{{ record.state === 1 ? '无' : record.banDesc }}</span>
                  </template>
                  <template v-else-if="column.key === 'action'">
                    <a-space size="small" wrap>
                      <a-button v-if="record.state === 1" size="small"
                        @click="banAuthDialog(record.authId)">禁用</a-button>
                      <a-button v-else type="primary" size="small" @click="openAuthDialog(record.authId)">开启</a-button>
                      <a-button v-if="getEndDateColor(record.endDate) === 3 || record.isFree == 1" danger size="small"
                        @click="deletePluginAuthDialog(record.authId)">删除</a-button>
                    </a-space>
                  </template>
                </template>
              </a-table>

              <!-- 手机端授权卡片列表 -->
              <div class="plugin-auth-card-list" v-if="PluginAuth.data && PluginAuth.data.length > 0">
                <a-card v-for="record in PluginAuth.data" :key="record.authId" class="mobile-card" :bordered="false">
                  <div class="mobile-card-head">
                    <span class="mobile-card-title">{{ record.includeName || record.pluginName }} - #{{
                      record.includesId }}</span>
                    <div style="display: flex; gap: 4px;">
                      <a-tag :color="record.state === 1 ? 'green' : 'red'">{{ record.state === 1 ? '正常' : '禁用'
                      }}</a-tag>
                    </div>
                  </div>
                  <div class="mobile-card-body">
                    <div class="mobile-field">
                      <span class="mobile-label">用户邮箱</span>
                      <span class="mobile-value">{{ record.userEmail }}</span>
                    </div>
                    <div class="mobile-field">
                      <span class="mobile-label">授权字段</span>
                      <span class="mobile-value">
                        <a-input v-model:value="record.host" size="small" @focus="cacheOrigin(record, 'host')"
                          @blur="onUpdateHost(record)" placeholder="域名/IP"></a-input>
                      </span>
                    </div>
                    <div class="mobile-field">
                      <span class="mobile-label">到期时间</span>
                      <span class="mobile-value">
                        <a-tag
                          :color="getEndDateColor(record.endDate) === 1 ? 'green' : (getEndDateColor(record.endDate) === 2 ? 'gold' : 'red')">
                          {{ record.endDate }}
                        </a-tag>
                      </span>
                    </div>
                    <div class="mobile-field">
                      <span class="mobile-label">版本</span>
                      <span class="mobile-value">{{ record.versionName || '-' }}</span>
                    </div>
                    <div class="mobile-field">
                      <span class="mobile-label">修改次数</span>
                      <span class="mobile-value">{{ record.modifyCount || 0 }} 次</span>
                      <a-button size="small" type="link" :disabled="!record.modifyHistory"
                        @click="openHistoryDialog(record)">历史</a-button>
                    </div>
                    <div v-if="record.state !== 1" class="mobile-field">
                      <span class="mobile-label">禁用原因</span>
                      <span class="mobile-value">{{ record.banDesc }}</span>
                    </div>
                  </div>
                  <div class="mobile-card-foot">
                    <a-button v-if="record.state === 1" size="small" @click="banAuthDialog(record.authId)">禁用</a-button>
                    <a-button v-else type="primary" size="small" @click="openAuthDialog(record.authId)">开启</a-button>
                    <a-button v-if="getEndDateColor(record.endDate) === 3 || record.isFree == 1" danger size="small"
                      @click="deletePluginAuthDialog(record.authId)">删除</a-button>
                  </div>
                </a-card>
              </div>

              <!-- 空状态 -->
              <a-empty v-if="(!PluginAuth.data || PluginAuth.data.length === 0)" description="暂无授权数据"
                style="padding: 32px;" />

              <!-- 分页 -->
              <div class="table-pagination plugin-auth-pagination">
                <a-pagination v-model:current="PluginAuth.currentPage" v-model:page-size="PluginAuth.pageSize"
                  :page-size-options="[10, 25, 50]" show-size-changer show-quick-jumper
                  :show-total="(total) => `共 ${total} 条`" :total="PluginAuth.total" @change="getPluginAuth" />
              </div>
            </a-tab-pane>

            <a-tab-pane tab="代理列表" key="second">
              <div class="table-toolbar">
                <a-select v-model:value="pluginAgent.pluginId" allowClear placeholder="Select" style="width: 160px;"
                  @change="getMyPluginsAgent()">
                  <a-select-option label="全部插件" :value="-1" />
                  <a-select-option v-for="item in deveploerData.list" :key="item.id" :value="item.id">
                    {{ item.name || item.includes_name }}
                  </a-select-option>
                </a-select>
                <a-input style="width: 200px;" v-model:value="pluginAgent.keyword" placeholder="邮箱/uid关键词" />
                <a-button type="primary" @click="getMyPluginsAgent()">搜索</a-button>
              </div>

              <!-- PC端代理列表表格 -->
              <a-table class="plugin-agent-table-pc" :data-source="pluginAgent.data" :pagination="false" row-key="id"
                :scroll="{ x: 1200 }" size="small" bordered :columns="pluginAgentColumns">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'state'">
                    <a-tag :color="record.state === 1 ? 'green' : 'red'">{{ record.state === 1 ? '正常' : '禁用' }}</a-tag>
                  </template>
                  <template v-else-if="column.key === 'banDesc'">
                    <span>{{ record.state === 1 ? '无' : record.ban_desc }}</span>
                  </template>
                  <template v-else-if="column.key === 'action'">
                    <a-space size="small">
                      <a-button v-if="record.state === 1" size="small" @click="banAgentDialog(record.id)">禁用</a-button>
                      <a-button v-else type="primary" size="small" @click="openAgentDialog(record.id)">开启</a-button>
                    </a-space>
                  </template>
                </template>
              </a-table>

              <!-- 手机端代理卡片列表 -->
              <div class="plugin-agent-card-list" v-if="pluginAgent.data && pluginAgent.data.length > 0">
                <a-card v-for="record in pluginAgent.data" :key="record.id" class="mobile-card" :bordered="false">
                  <div class="mobile-card-head">
                    <span class="mobile-card-title">UID #{{ record.uid }} - {{ record.grade_name }}</span>
                    <a-tag :color="record.state === 1 ? 'green' : 'red'">{{ record.state === 1 ? '正常' : '禁用' }}</a-tag>
                  </div>
                  <div class="mobile-card-body">
                    <div class="mobile-field">
                      <span class="mobile-label">用户邮箱</span>
                      <span class="mobile-value">{{ record.user_email }}</span>
                    </div>
                    <div class="mobile-field">
                      <span class="mobile-label">插件</span>
                      <span class="mobile-value">{{ record.include_name }} (ID: {{ record.includes_id }})</span>
                    </div>
                    <div class="mobile-field">
                      <span class="mobile-label">代理等级</span>
                      <span class="mobile-value">{{ record.grade_name }}</span>
                    </div>
                    <div v-if="record.state !== 1" class="mobile-field">
                      <span class="mobile-label">禁用原因</span>
                      <span class="mobile-value">{{ record.ban_desc }}</span>
                    </div>
                  </div>
                  <div class="mobile-card-foot">
                    <a-button v-if="record.state === 1" size="small" @click="banAgentDialog(record.id)">禁用</a-button>
                    <a-button v-else type="primary" size="small" @click="openAgentDialog(record.id)">开启</a-button>
                  </div>
                </a-card>
              </div>

              <!-- 空状态 -->
              <a-empty v-if="(!pluginAgent.data || pluginAgent.data.length === 0)" description="暂无代理数据"
                style="padding: 32px;" />

              <!-- 分页 -->
              <div class="table-pagination plugin-agent-pagination">
                <a-pagination v-model:current="pluginAgent.currentPage" v-model:page-size="pluginAgent.pageSize"
                  :page-size-options="[10, 25, 50]" show-size-changer show-quick-jumper
                  :show-total="(total) => `共 ${total} 条`" :total="pluginAgent.total" @change="getMyPluginsAgent" />
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>

  <!-- 修改历史 -->
  <a-modal v-model:open="historyDialog.isShow" :title="historyDialog.title" :width="640" centered :footer="null">
    <div class="history-notice">
      1.每月可修改一次授权，2.每个授权最多修改10次，超出后可付费修改（从余额扣除）
    </div>
    <a-table :data-source="historyDialog.list" :pagination="false" row-key="time" size="small" bordered>
      <a-table-column type="index" label="序号" width="60" align="center" />
      <a-table-column label="修改前" data-index="old_host" :width="160">
        <template #bodyCell="{ record }">
          <span style="color: #ff4d4f;">{{ record.old_host }}</span>
        </template>
      </a-table-column>
      <a-table-column label="修改后" data-index="new_host" :width="160">
        <template #bodyCell="{ record }">
          <span style="color: #52c41a;">{{ record.new_host }}</span>
        </template>
      </a-table-column>
      <a-table-column label="类型" width="80" align="center">
        <template #bodyCell="{ record }">
          <a-tag :color="record.is_paid == 1 ? 'blue' : 'default'">
            {{ record.is_paid == 1 ? '付费' : '免费' }}
          </a-tag>
        </template>
      </a-table-column>
      <a-table-column data-index="time" label="修改时间" width="180" align="center" />
    </a-table>
    <a-empty v-if="historyDialog.list.length === 0" description="暂无历史修改记录" />
    <div style="text-align: right; margin-top: 16px;">
      <a-button type="primary" @click="historyDialog.isShow = false">关闭</a-button>
    </div>
  </a-modal>

  <!-- 禁用原因输入对话框 -->
  <a-modal v-model:open="banReasonVisible" :title="banReasonTitle" :width="420" centered :footer="null">
    <a-input type="textarea" :rows="3" v-model:value="banReason" placeholder="请输入禁用原因" />
    <div style="text-align: right; margin-top: 16px;">
      <a-button @click="banReasonVisible = false">取消</a-button>
      <a-button type="primary" @click="confirmBan">确定</a-button>
    </div>
  </a-modal>
</template>
<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isNull, openBox } from "@/utils/publicMethods"
import { message, Modal } from 'ant-design-vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
  components: {
    UserHead,
    HeadTop
  },
  computed: {
    pluginAuthColumns() {
      return [
        { title: '用户邮箱', dataIndex: 'userEmail', key: 'userEmail', width: 180 },
        { title: '插件ID', dataIndex: 'includesId', key: 'includesId', width: 80, align: 'center' },
        { title: '插件名称', dataIndex: 'includeName', key: 'includeName', width: 140 },
        { title: '功能版本', dataIndex: 'versionName', key: 'versionName', width: 100, align: 'center' },
        { title: '添加者UID', dataIndex: 'addUid', key: 'addUid', width: 90, align: 'center' },
        { title: '授权字段', key: 'host', width: 180 },
        { title: '添加时间', dataIndex: 'addDate', key: 'addDate', width: 170 },
        { title: '到期时间', key: 'endDate', width: 120, align: 'center' },
        { title: '类型', key: 'isFree', width: 80, align: 'center' },
        { title: '状态', key: 'state', width: 80, align: 'center' },
        { title: '修改次数', dataIndex: 'modifyCount', key: 'modifyCount', width: 80, align: 'center' },
        { title: '历史记录', key: 'modifyHistory', width: 100, align: 'center' },
        { title: '禁用原因', key: 'banDesc', width: 120 },
        { title: '操作', key: 'action', width: 180, align: 'center' },
      ];
    },
    pluginAgentColumns() {
      return [
        { title: '用户邮箱', dataIndex: 'user_email', key: 'user_email', width: 180 },
        { title: 'UID', dataIndex: 'uid', key: 'uid', width: 80, align: 'center' },
        { title: '插件ID', dataIndex: 'includes_id', key: 'includes_id', width: 80, align: 'center' },
        { title: '插件名称', dataIndex: 'include_name', key: 'include_name', width: 140 },
        { title: '代理名称', dataIndex: 'grade_name', key: 'grade_name', width: 120 },
        { title: '状态', key: 'state', width: 80, align: 'center' },
        { title: '禁用原因', key: 'banDesc', width: 140 },
        { title: '操作', key: 'action', width: 120, align: 'center' },
      ];
    }
  },
  watch: {
    activeName: function (val) {
      if (val == 'second') {
        this.getMyPluginsAgent();
      } else if (val == 'first') {
        this.getPluginAuth();
      }
    },
  },
  data() {
    return {
      activeName: "first",
      PluginAuth: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
        data: [],
        keyword: "",
        pluginId: null,
      },
      pluginAgent: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
        data: [],
        keyword: "",
        pluginId: "全部插件"
      },
      select_includes: -1,
      deveploerData: {},
      historyDialog: {
        isShow: false,
        title: "修改历史记录",
        list: []
      },
      banReasonVisible: false,
      banReasonTitle: "",
      banReason: "",
      banReasonCallback: null,
      isDeveloper: 0,
      deveploerConf: {
        apiUrl: ""
      },
    }
  },
  methods: {
    goApiUrl() {
      location.href = this.deveploerConf.apiUrl;
    },
    getInfo() {
      openLoading()
      const headers = {
        'token': localStorage.getItem("token")
      }
      axios.get(baseURL + '/dev/getInfo', { timeout: 30000, headers })
        .then(res => {
          if (res.data.code == 200) {
            this.isDeveloper = 1;
            this.deveploerData = res.data.data
          } else if (res.data.code == 403) {
            this.isDeveloper = 0;
            this.deveploerConf.apiUrl = res.data.data;
            openBox(res.data.data)
          }
          else {
            message.error(res.data.msg)
          }
          if (res.data.code == 401) {
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);

          }
        }).catch(err => {
          message.error(err)
        }).finally(() => {
          fullscreenLoading.close()
        })
    },
    getMyPluginsAgent() {
      openLoading()
      const headers = {
        'token': localStorage.getItem("token")
      }
      axios.post(baseURL + "/dev/getMyPluginsAgent", {
        pluginId: this.pluginAgent.pluginId == "全部插件" || this.pluginAgent.pluginId == -1 ? null : this.pluginAgent.pluginId,
        pageSize: this.pluginAgent.pageSize,
        currentPage: this.pluginAgent.currentPage,
        keyword: this.pluginAgent.keyword
      }, { timeout: 30000, headers: headers })
        .then(res1 => {
          fullscreenLoading.close()
          if (res1.data.code == 401) {
            message.error(res1.data.msg)
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
            return
          }
          else if (res1.data.code == 200) {
            this.pluginAgent.data = res1.data.data.data;
            this.pluginAgent.total = res1.data.data.count;
          }
          else {
            message.error(res1.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          message.error('获取代理用户失败' + err.message)
        })
    },
    getPluginAuth() {
      openLoading()
      const headers = {
        'token': localStorage.getItem("token")
      }
      axios.post(baseURL + "/dev/getMyPluginAuth", {
        pluginId: this.select_includes == "全部插件" || this.select_includes == -1 ? null : this.select_includes,
        pageSize: this.PluginAuth.pageSize,
        currentPage: this.PluginAuth.currentPage,
        keyword: this.PluginAuth.keyword
      }, { timeout: 30000, headers: headers })
        .then(res1 => {
          fullscreenLoading.close()
          if (res1.data.code == 401) {
            message.error(res1.data.msg)
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
            return
          }
          else if (res1.data.code == 200) {
            this.PluginAuth.data = res1.data.data.data;
            this.PluginAuth.total = res1.data.data.total;
          }
          else {
            message.error(res1.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          message.error('获取授权失败' + err.message)
        })
    },
    parseHistory(historyStr) {
      if (!historyStr) return [];
      try {
        const arr = JSON.parse(historyStr);
        return Array.isArray(arr) ? arr : [];
      } catch {
        return [];
      }
    },
    openHistoryDialog(row) {
      const includeName = row.includeName || row.includesName || '';
      this.historyDialog.title = (includeName ? includeName + ' - ' : '') + '修改历史记录';
      this.historyDialog.list = this.parseHistory(row.modifyHistory);
      this.historyDialog.isShow = true;
    },
    deletePluginAuthDialog(authId) {
      Modal.confirm({
        title: '提示',
        content: '此操作将永久删除该授权, 是否继续?',
        okText: '确定',
        cancelText: '取消',
        okType: 'warning',
        onOk: () => {
          const headers = {
            'token': localStorage.getItem("token")
          }
          axios.get(baseURL + `/dev/deleteAuthById?authId=${authId}`, { timeout: 30000, headers: headers })
            .then(res1 => {
              fullscreenLoading.close()
              if (res1.data.code == 401) {
                message.error(res1.data.msg)
                setTimeout(() => {
                  location.href = "/Login"
                }, 1000);
                return
              }
              else if (res1.data.code == 200) {
                message.success(res1.data.msg)
                this.getPluginAuth()
              }
              else {
                message.error(res1.data.msg)
              }
            })
            .catch(err => {
              fullscreenLoading.close()
              console.log(err)
              message.error('获取等级信息失败：' + err.message)
            })
        },
        onCancel: () => {
          console.log('cancel')
        }
      })
    },
    cacheOrigin(record, field) {
      const key = field + '_origin'
      if (!(key in record)) {
        record[key] = (record[field] ?? '') + ''
      }
    },
    onUpdateHost(record) {
      const origin = record.host_origin ?? ''
      const current = record.host ?? ''
      if (current === origin) return
      record.host_origin = current
      this.updatePluginAuth(record.authId, 1, null, current)
    },
    updatePluginAuth(authId, status, banDesc, host) {
      const data = {
        status: status,
        banDesc: banDesc,
        host: host
      };
      axios.post(baseURL + "/dev/updatePluginAuth?authId=" + authId,
        data, {
        timeout: 30000,
        headers: {
          'token': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.code == 200) {
          message.success(res.data.msg)
          this.getPluginAuth();
        }
        else {
          message.error(res.data.msg)
        }
      })
    },
    updatePluginAgent(id, status, banDesc, grade) {
      const data = {
        state: status,
        banDesc: banDesc,
        grade: grade
      };
      axios.post(baseURL + "/dev/updatePluginAgent?id=" + id,
        data, {
        timeout: 30000,
        headers: {
          'token': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.code == 200) {
          message.success(res.data.msg)
          this.getMyPluginsAgent();
        }
        else {
          message.error(res.data.msg)
        }
      })
    },
    openBanReasonDialog(title, callback) {
      this.banReasonTitle = title;
      this.banReason = '';
      this.banReasonCallback = callback;
      this.banReasonVisible = true;
    },
    confirmBan() {
      const reason = this.banReason;
      const cb = this.banReasonCallback;
      this.banReasonVisible = false;
      this.banReasonCallback = null;
      if (cb) cb(reason);
    },
    banAgentDialog(id) {
      this.openBanReasonDialog('请输入禁用原因', (value) => {
        this.updatePluginAgent(id, 2, value, null);
      })
    },
    openAgentDialog(id) {
      this.updatePluginAgent(id, 1, null, null)
    },
    banAuthDialog(authId) {
      this.openBanReasonDialog('请输入禁用原因', (value) => {
        this.updatePluginAuth(authId, 2, value, null);
      })
    },
    openAuthDialog(authId) {
      this.updatePluginAuth(authId, 1, null, null)
    },
    deleteAuthDialog(empower_id) {
      this.deleteAuth_id = empower_id
      this.openDialog('消息', '您确定要删除此授权吗？此操作不可撤销', true, 'deleteAuth')
    },
    getEmpowerIncludesList() {
      openLoading()
      const headers = {
        'token': localStorage.getItem("token")
      }
      var data = new FormData()
      data.append("act", 'getEmpowerIncludesList')
      axios.post(baseURL + "/userApi/getIncludesAgent", data, { timeout: 30000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            message.error(res.data.msg)
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
            return
          }
          else if (res.data.code == 200) {
            this.includes_data.includes_list = res.data.data;
          }
          else {
            message.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          message.error('获取代理插件列表失败：' + err.message)
        })
    },
    getEndDateColor(end_date) {
      var endDate = new Date(end_date);
      if (endDate.getTime() < new Date().getTime()) {
        //已过期
        return 3;
      }
      if (endDate.getTime() < new Date().getTime() + 1000 * 60 * 60 * 24 * 3) {
        //即将过期
        return 2;
      }
      return 1;
    }
  },
  mounted() {
    window.ResizeObserver = this.$customResizeObserver
    this.getPluginAuth();
    this.getInfo();
  }
})
</script>
